// Simple API service using fetch
const API_BASE_URL = process.env.REACT_APP_BASE_URL + "/api";

// Helper function to make API requests
const apiRequest = async (endpoint, options = {}) => {
    // console.log("🌐 API REQUEST - Starting");
    // console.log("🛣️  Endpoint:", endpoint);
    // console.log("⚙️  Options:", options);

  const token = localStorage.getItem("token");
  // console.log(
  //   "🔑 Token from localStorage:",
  //   token ? "Token present" : "No token",
  // );
  // console.log("🔑 Token length:", token?.length || 0);

  // Validate token before using it
  const validToken =
    token &&
    typeof token === "string" &&
    token.trim() !== "" &&
    token !== "undefined" &&
    token !== "null";
  // console.log("✅ Token validation:", validToken ? "Valid" : "Invalid");

  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(validToken && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  // console.log("📋 Request headers:", config.headers);

  try {
      // console.log("📡 Sending request to:", `${API_BASE_URL}${endpoint}`);
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

    // console.log("📡 Response status:", response.status);
    // console.log("📡 Response ok:", response.ok);

    if (!response.ok) {
      console.log("❌ API REQUEST - Response not OK");

      let errorData = null;
      try {
        errorData = await response.json();
      } catch (parseError) {
        console.log("📄 Could not parse error response JSON");
      }

      if (response.status === 401) {
        console.log("🚨 401 UNAUTHORIZED - Checking if should logout");

        if (errorData) {
          console.log("📄 401 Error data:", errorData);
        }

        // Only logout if it's a token-related error
        const shouldLogout =
          !errorData ||
          errorData.message?.includes("Token") ||
          errorData.message?.includes("token") ||
          errorData.message?.includes("expired") ||
          errorData.message?.includes("Invalid") ||
          !errorData.message; // Default to logout if no message

        if (shouldLogout) {
          console.log(
            "🧹 Token-related 401 - Clearing localStorage and redirecting to login",
          );
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.href = "/login";
          return;
        } else {
          console.log("🔐 Non-token 401 error - Not logging out");
        }
      }

      console.log("❌ API REQUEST - Error:", response.status);
      const message =
        errorData?.message ||
        errorData?.error ||
        `HTTP error! status: ${response.status}`;

      const error = new Error(message);
      error.status = response.status;
      error.response = {
        status: response.status,
        data: errorData || { message },
      };

      throw error;
    }

    console.log("✅ API REQUEST - Response OK");
    const data = await response.json();
    console.log("📥 Response data received");
    return { data };
  } catch (error) {
    console.log("💥 API REQUEST - Error:", error.message);
    console.error("API request failed:", error);
    throw error;
  }
};

// API methods
const api = {
  get: (endpoint, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;
    return apiRequest(url);
  },

  post: (endpoint, data = {}) => {
    return apiRequest(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  put: (endpoint, data = {}) => {
    return apiRequest(endpoint, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },

  patch: (endpoint, data = {}) => {
    return apiRequest(endpoint, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
  },

  delete: (endpoint) => {
    return apiRequest(endpoint, {
      method: "DELETE",
    });
  },
};

export default api;
